import styled from 'styled-components';
import React, { useState, useEffect } from 'react';
import { MessageRepository } from '@amityco/js-sdk';
import { FormattedMessage, useIntl } from 'react-intl';
import Popover from '../../../core/components/Popover';
import Menu, { MenuItem } from '../../../core/components/Menu';
import { notification } from '../../../core/components/Notification';
import { MessageOptionsIcon, SaveIcon, CloseIcon, EditingInput, EditingContainer } from './styles';
const StyledPopover = styled(Popover) `
  ${({ align, theme }) => align === 'end' && `color: ${theme.palette.neutral.main};`}
`;
const Flagging = ({ messageId }) => {
    const [isFlaggedByMe, setIsFlaggedByMe] = useState(null);
    useEffect(() => {
        if (!messageId)
            return;
        MessageRepository.isFlaggedByMe(messageId).then(setIsFlaggedByMe);
    }, [messageId]);
    const flagMessage = () => {
        MessageRepository.flag(messageId).then(() => {
            setIsFlaggedByMe(true);
        });
    };
    const unflagMessage = () => {
        MessageRepository.unflag(messageId).then(() => {
            setIsFlaggedByMe(false);
        });
    };
    if (isFlaggedByMe === null)
        return null;
    return isFlaggedByMe ? (React.createElement(MenuItem, { onClick: unflagMessage },
        React.createElement(FormattedMessage, { id: "message.unflag" }))) : (React.createElement(MenuItem, { onClick: flagMessage },
        React.createElement(FormattedMessage, { id: "message.flag" })));
};
const Options = ({ isIncoming, messageId, data, isSupportedMessageType, popupContainerRef }) => {
    // const popupContainerRef = useRef();
    const [text, setText] = useState('');
    const [isEditing, setIsEditing] = useState(false);
    const edit = (e) => {
        e.stopPropagation();
        setIsEditing(true);
    };
    const [isOpen, setIsOpen] = useState(false);
    const { formatMessage } = useIntl();
    const open = () => {
        setText(data.text || data);
        setIsOpen(true);
        setIsEditing(false);
    };
    const close = () => {
        setIsOpen(false);
    };
    const save = () => {
        MessageRepository.updateMessage({ messageId, data: { text } })
            .then(close)
            .catch(() => {
            notification.error({
                content: formatMessage({ id: 'message.saveOptionsError' }),
            });
        });
    };
    const deleteMessage = () => {
        MessageRepository.deleteMessage(messageId).then(close);
    };
    const menu = (React.createElement(Menu, null,
        !isIncoming && isSupportedMessageType && (React.createElement(MenuItem, { "data-qa-anchor": "message-menu-item-edit", onClick: edit },
            React.createElement(FormattedMessage, { id: "message.edit" }))),
        isIncoming && React.createElement(Flagging, { messageId: messageId }),
        !isIncoming && (React.createElement(MenuItem, { "data-qa-anchor": "message-menu-item-delete", onClick: deleteMessage },
            React.createElement(FormattedMessage, { id: "message.delete" })))));
    const editing = (React.createElement(EditingContainer, null,
        React.createElement(EditingInput, { "data-qa-anchor": "message-edit-input", autoFocus: true, value: text, onChange: (e) => setText(e.target.value), onKeyDown: (e) => {
                if (e.key === 'Enter')
                    save();
                if (e.key === 'Escape')
                    close();
            } }),
        React.createElement(SaveIcon, { "data-qa-anchor": "message-save-button", onClick: save }),
        React.createElement(CloseIcon, { onClick: close })));
    return (React.createElement(StyledPopover, { isOpen: isOpen, positions: ['bottom', 'top'], align: isIncoming ? 'start' : 'end', content: isEditing ? editing : menu, parentElement: popupContainerRef.current, onClickOutside: close },
        React.createElement("div", { "data-qa-anchor": "message-options-button", role: "button", tabIndex: 0, onClick: open, onKeyDown: open },
            React.createElement(MessageOptionsIcon, null))));
};
export default Options;
//# sourceMappingURL=Options.js.map